import styled from 'styled-components';

export const ContentWrapper = styled.span`
  margin-left: 5px;
`;
